import React from 'react';
import DatePicker from 'react-datepicker';
import classNames from 'classnames';

import { ReactComponent as CalendarIcon } from '../../../assets/images/calendar-icon.svg';

import styles from './CustomDatePicker.module.scss';

const CustomDatePicker = ({
  disabled = false,
  value = null,
  shouldCloseOnSelect = true,
  showTimeSelect = false,
  showPopperArrow = false,
  dateFormat = 'MM/dd/yyyy',
  onChange = () => {},
}) => (
  <div className={styles.container}>
    <div className={styles.datePickerContainer}>
      <DatePicker
        dateFormat={dateFormat}
        className={classNames(styles.removeBorder)}
        calendarClassName={styles.calendarContainer}
        showPopperArrow={showPopperArrow}
        showTimeSelect={showTimeSelect}
        disabled={disabled}
        selected={value}
        onChange={onChange}
        shouldCloseOnSelect={shouldCloseOnSelect}
        minDate={new Date()}
        popperPlacement="bottom-start"
      />
    </div>
    <CalendarIcon className="ml-auto" />
  </div>
);

export default CustomDatePicker;
